import { render, staticRenderFns } from "./job.vue?vue&type=template&id=6347ef2a&scoped=true"
import script from "./job.vue?vue&type=script&lang=js"
export * from "./job.vue?vue&type=script&lang=js"
import style0 from "./job.vue?vue&type=style&index=0&id=6347ef2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6347ef2a",
  null
  
)

export default component.exports